// extracted by mini-css-extract-plugin
export var contentContainer = "contentContainer__hZG0";
export var layout = "layout__k0CB";